import { render, staticRenderFns } from "./Semaphore.vue?vue&type=template&id=5de5a9c8&scoped=true&"
import script from "./Semaphore.vue?vue&type=script&lang=js&"
export * from "./Semaphore.vue?vue&type=script&lang=js&"
import style0 from "./Semaphore.vue?vue&type=style&index=0&id=5de5a9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de5a9c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de5a9c8')) {
      api.createRecord('5de5a9c8', component.options)
    } else {
      api.reload('5de5a9c8', component.options)
    }
    module.hot.accept("./Semaphore.vue?vue&type=template&id=5de5a9c8&scoped=true&", function () {
      api.rerender('5de5a9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/Semaphore.vue"
export default component.exports